import { Breadcrumbs } from '../../components/layout';
import { WorkList } from '../../components/portfolio/WorkList';
import { works } from '../../content';
import './works.scss';

export const Works = () => {
  const breadcrumbs = [{ name: 'Our works', isActive: true }];

  return (
    <>
      <div className="container">
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <h1>Our works</h1>
      </div>
      <section className="container pb-2 pb-lg-3">
        <WorkList works={works} />
      </section>
    </>
  );
};
